import { render, staticRenderFns } from "./StreamWeb.vue?vue&type=template&id=d0a5a096&scoped=true&"
import script from "./StreamWeb.vue?vue&type=script&lang=js&"
export * from "./StreamWeb.vue?vue&type=script&lang=js&"
import style0 from "./StreamWeb.vue?vue&type=style&index=0&id=d0a5a096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a5a096",
  null
  
)

export default component.exports